import React from 'react';
import './HabitInsights.css';
import { getHabitRecommendations } from '../utils/personalization';

const HabitInsights = ({ userProfile, habitSchedules, personalizedHabits }) => {
  const recommendations = getHabitRecommendations(userProfile, habitSchedules, personalizedHabits);
  
  // Calculate some basic stats
  const totalHabits = personalizedHabits.length;
  const completedToday = Object.keys(habitSchedules).filter(habitId => {
    const schedule = habitSchedules[habitId];
    const today = new Date().toISOString().split('T')[0];
    return schedule.completionHistory[today];
  }).length;

  const getInsightIcon = (type) => {
    switch (type) {
      case 'improvement':
        return '💡';
      case 'new-habit':
        return '✨';
      case 'celebration':
        return '🎉';
      default:
        return '💫';
    }
  };

  const getPersonalizedTips = () => {
    const { skinType, ageRange } = userProfile;
    const tips = [];

    // Skin type specific tips
    if (skinType === 'dry') {
      tips.push({
        icon: '💧',
        title: 'Hydration Focus',
        message: 'Your dry skin loves layering hydrating products. Apply serums on damp skin for better absorption.'
      });
    } else if (skinType === 'oily') {
      tips.push({
        icon: '🧼',
        title: 'Oil Control',
        message: 'Don\'t skip moisturizer! Oil-free formulas help balance your skin without clogging pores.'
      });
    } else if (skinType === 'sensitive') {
      tips.push({
        icon: '🌸',
        title: 'Gentle Care',
        message: 'Less is more for sensitive skin. Stick to fragrance-free, minimal ingredient products.'
      });
    }

    // Age-specific tips
    if (ageRange === '30s' || ageRange === '40s' || ageRange === '50plus') {
      tips.push({
        icon: '🧬',
        title: 'Anti-Aging Focus',
        message: 'Consistency with retinol and sunscreen is key. Start slow and build up tolerance.'
      });
    }

    return tips;
  };

  const personalizedTips = getPersonalizedTips();

  return (
    <div className="habit-insights">
      <div className="insights-header">
        <h3>Your Skincare Insights</h3>
        <div className="completion-badge">
          <span className="badge-text">{completedToday}/{totalHabits} today</span>
        </div>
      </div>

      {/* Recommendations */}
      {recommendations.length > 0 && (
        <div className="recommendations-section">
          <h4>Recommendations</h4>
          <div className="recommendations-list">
            {recommendations.map((rec, index) => (
              <div key={index} className={`recommendation-card ${rec.type}`}>
                <span className="rec-icon">{getInsightIcon(rec.type)}</span>
                <div className="rec-content">
                  <h5>{rec.title}</h5>
                  <p>{rec.message}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Personalized Tips */}
      {personalizedTips.length > 0 && (
        <div className="tips-section">
          <h4>Tips for You</h4>
          <div className="tips-list">
            {personalizedTips.map((tip, index) => (
              <div key={index} className="tip-card">
                <span className="tip-icon">{tip.icon}</span>
                <div className="tip-content">
                  <h5>{tip.title}</h5>
                  <p>{tip.message}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Quick Stats */}
      <div className="quick-stats">
        <div className="stat-card">
          <span className="stat-icon">📊</span>
          <div className="stat-info">
            <span className="stat-value">{totalHabits}</span>
            <span className="stat-label">Total Habits</span>
          </div>
        </div>
        <div className="stat-card">
          <span className="stat-icon">🎯</span>
          <div className="stat-info">
            <span className="stat-value">{Math.round((completedToday / totalHabits) * 100)}%</span>
            <span className="stat-label">Today's Progress</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HabitInsights;
